import { observer } from "mobx-react-lite";
import { SectionBackground } from "./SectionBackground";
import { CustomDropdown } from "../../../components/dropdown/Dropdown";
import { useFontDesk } from "../../../context/frontDeskContext";
import { useCreateLeagueMatchStore } from "../../../store/StoreContext";

export const SelectLocation = observer(() => {
  const { locations } = useFontDesk();
  const createLeagueMatchStore = useCreateLeagueMatchStore();
  return (
    <SectionBackground title={"Select location of the match"}>
      <div style={{ height: 20 }} />

      <div style={{ display: "flex", justifyContent: "center" }}>
        <CustomDropdown
          value={createLeagueMatchStore.selectedLocation}
          onChange={(v) => {
            createLeagueMatchStore.setSelectedLocation(v);
          }}
          options={locations}
          optionLabel="locationName"
          placeholder={"Select a location"}
          filter
          filterDelay={400}
          className="w-full md:w-14rem"
          style={{ width: "90%", alignSelf: "center" }}
        />
      </div>
    </SectionBackground>
  );
});
